import React from "react";
import { ActionIcon, Tooltip } from "@mantine/core";
import { Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";

type EmployeeAuditLogButtonProps = {
  employeeId: number | string;
  employeeName: string;
};

const EmployeeAuditLogButton: React.FC<EmployeeAuditLogButtonProps> = ({
  employeeId,
  employeeName,
}) => {
  const navigate = useNavigate();

  return (
    <Tooltip label="View audit log" withArrow>
      <ActionIcon
        variant="transparent"
        onClick={() => {
          navigate(`/employees/${employeeId}/audit-log`, {
            state: { employeeName },
          });
        }}
        aria-label={`View audit log for ${employeeName}`}
      >
        <Eye size={18} />
      </ActionIcon>
    </Tooltip>
  );
};

export default EmployeeAuditLogButton;
